<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addDelivery") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 class="mt-5 font-weight-bold">
            {{ $t("TITLES.personal_data") }}
          </h5>
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="6"
            identifier="delivery_man_image"
            :placeholder="$t('PLACEHOLDERS.user_image')"
            @selectImage="selectImage"
          />
          <base-image-upload-input
            col="6"
            identifier="idCardFront"
            :placeholder="$t('PLACEHOLDERS.id_image')"
            @selectImage="selectIdCard"
            required
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: First Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.first_name')"
            v-model.trim="data.firstName"
            required
          />
          <!-- End:: First Name Input -->

          <!-- Start:: Last Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.last_name')"
            v-model.trim="data.lastName"
            required
          />
          <!-- End:: Last Name Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            required
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Account Status Switch -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Account Status Switch -->

          <!-- Start:: Bank Account Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">{{ $t("TITLES.bank_data") }}</h5>
          <base-select-input
            col="6"
            :optionsList="banks"
            :placeholder="$t('PLACEHOLDERS.bank_name')"
            v-model="data.bankName"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_num')"
            v-model.trim="data.bankAccountNumber"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.iban')"
            v-model.trim="data.iban"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.identity')"
            v-model.trim="data.idNumber"
            required
          />
          <!-- End:: Bank Account Details -->

          <!-- Start:: Vehicle Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">{{ $t("TITLES.vechile_data") }}</h5>
          <base-select-input
            col="6"
            :optionsList="vehicleTypes"
            :placeholder="$t('PLACEHOLDERS.vechiles_type')"
            v-model="data.vehicleType"
            @input="onVehicleTypeChange"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vehiclePlateNumber')"
            v-model.trim="data.vehiclePlateNumber"
            required
            v-if="!data.is_bicycle"
          />
          <base-image-upload-input
            col="6"
            identifier="vehicleLicenseFront"
            :placeholder="$t('PLACEHOLDERS.vehicle_license_image_face')"
            @selectImage="selectVehicleLicenseFront"
            v-if="!data.is_bicycle"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="vehicleLicenseBack"
            :placeholder="$t('PLACEHOLDERS.vehicle_license_image_back')"
            @selectImage="selectVehicleLicenseBack"
            v-if="!data.is_bicycle"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="driverLicenseFront"
            :placeholder="$t('PLACEHOLDERS.driving_license_image_face')"
            @selectImage="selectDriverLicenseFront"
            v-if="!data.is_bicycle"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="driverLicenseBack"
            :placeholder="$t('PLACEHOLDERS.driving_license_image_back')"
            @selectImage="selectDriverLicenseBack"
            v-if="!data.is_bicycle"
            required
          />
          <!-- End:: Vehicle Details -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateDeliveryMan",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        image: {
          path: null,
          file: null,
        },
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        password: null,
        passwordConfirmation: null,
        active: true,
        bankName: null,
        bankAccountNumber: null,
        iban: null,
        idNumber: null,
        vehicleType: null,
        vehiclePlateNumber: null,
        vehicleLicenseFront: {
          path: null,
          file: null,
        },
        vehicleLicenseBack: {
          path: null,
          file: null,
        },
        driverLicenseFront: {
          path: null,
          file: null,
        },
        driverLicenseBack: {
          path: null,
          file: null,
        },
        idCard: {
          path: null,
          file: null,
        },
        is_bicycle: true,
      },
      banks: [],
      vehicleTypes: [
        { id: 1, name: this.$t("VEHICLE_TYPES.bicycle"), value: "bicycle" },
        {
          id: 2,
          name: this.$t("VEHICLE_TYPES.motorcycle"),
          value: "motorcycle",
        },
        { id: 3, name: this.$t("VEHICLE_TYPES.car"), value: "car" },
      ],
    };
  },

  computed: {
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
  },

  methods: {
    // Handle image selection for personal image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Handle vehicle license front image selection
    selectVehicleLicenseFront(selectedImage) {
      this.data.vehicleLicenseFront = selectedImage;
    },

    // Handle vehicle license back image selection
    selectVehicleLicenseBack(selectedImage) {
      this.data.vehicleLicenseBack = selectedImage;
    },

    // Handle driver license front image selection
    selectDriverLicenseFront(selectedImage) {
      this.data.driverLicenseFront = selectedImage;
    },

    // Handle driver license back image selection
    selectDriverLicenseBack(selectedImage) {
      this.data.driverLicenseBack = selectedImage;
    },

    // Handle ID card image selection
    selectIdCard(selectedImage) {
      this.data.idCard = selectedImage;
    },

    // Handle vehicle type change
    onVehicleTypeChange() {
      if (this.data.vehicleType.value == "bicycle") {
        this.data.vehiclePlateNumber = null;
        this.data.is_bicycle = true;
      } else {
        this.data.is_bicycle = false;
      }
    },

    // Validate form inputs before submission
    validateFormInputs() {
      this.isWaitingRequest = true;

      // Basic validation for required fields
      if (!this.data.firstName || !this.data.lastName) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      }
      if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.phone"));
        return;
      }
      if (!this.data.password || this.data.password.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      }
      if (this.data.password !== this.data.passwordConfirmation) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordMismatch"));
        return;
      }

      this.submitForm();
    },

    // Submit form data
    async submitForm() {
      const formData = new FormData();
      if (this.data.image.file) {
        formData.append("avatar", this.data.image.file);
      }
      formData.append("first_name", this.data.firstName);
      formData.append("last_name", this.data.lastName);
      if (this.data.email) {
        formData.append("email", this.data.email);
      }
      formData.append("mobile", this.data.phone);
      formData.append("password", this.data.password);
      formData.append("password_confirmation", this.data.passwordConfirmation);
      formData.append("is_active", this.data.active ? 1 : 0);
      formData.append("bank_id", this.data.bankName?.id);
      formData.append("account_number", this.data.bankAccountNumber);
      formData.append("iban", this.data.iban);
      formData.append("id_number", this.data.idNumber);
      formData.append("vehicle_type", this.data.vehicleType?.value);
      if (this.data.vehicleType?.value != "bicycle") {
        formData.append("vehicle_plate_number", this.data.vehiclePlateNumber);
      }
      // Append images if provided
      if (this.data.vehicleType?.value != "bicycle") {
        console.log(this.data.vehicleLicenseFront);
        formData.append(
          "vehicle_license_image_face",
          this.data.vehicleLicenseFront.file
        );
      }
      if (this.data.vehicleType?.value != "bicycle") {
        formData.append(
          "vehicle_license_image_back",
          this.data.vehicleLicenseBack.file
        );
      }
      if (this.data.vehicleType?.value != "bicycle") {
        formData.append(
          "driving_license_image_face",
          this.data.driverLicenseFront.file
        );
      }
      if (this.data.vehicleType?.value != "bicycle") {
        formData.append(
          "driving_license_image_back",
          this.data.driverLicenseBack.file
        );
      }
      formData.append("id_image", this.data.idCard.file);

      try {
        await this.$axios.post("deliveries", formData);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push("/DeliveryMen/all");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getBanks() {
      try {
        const response = await this.$axios.get("/banks?page=0&limit=0");
        this.banks = response.data.data.data;
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    },
  },

  async created() {
    await this.getBanks();
  },
};
</script>
